<h2 mat-dialog-title>
  {{ "Update Properties" }}
</h2>

<mat-dialog-content>
  <mat-vertical-stepper [linear]="isLinear" #stepper>
    <mat-step
      *ngFor="let currentForm of forms; let i = index"
      [stepControl]="currentForm"
    >
      <form [formGroup]="forms[i]">
        <ng-template matStepLabel
          >Edit properties for
          {{ currentForm.controls['name'].value }}
        </ng-template>
        <div *ngIf="i == 0 && files.length > 1" align="end">
          <mat-label>Apply to all files</mat-label>
          <input
            type="checkbox"
            [checked]="applyToAllFiles"
            (change)="applyToAll($event)"
          />
        </div>

        <mat-form-field class="adf-full-width">
          <input
            id="broking-document-name-input_{{ i }}"
            placeholder="Name"
            matInput
            readonly
            [formControl]="$any(currentForm).controls['name']"
          />

          <mat-error class="error-message" *ngIf="currentForm.get('name')?.hasError('required') &&
          (currentForm.get('name')?.dirty || currentForm.get('name')?.touched)">
            {{ "Name is a required field" }}
          </mat-error>

        </mat-form-field>
        <br/>

        <mat-form-field
          *ngIf="!applyToAllFiles || i == 0"
          class="adf-full-width"
        >
          <mat-select
            id="broking-document-type-input_{{ i }}"
            [formControl]="$any(currentForm).controls['documentType']"
            placeholder="Document Type"
            required
          >
            <mat-option></mat-option>
            <mat-option *ngFor="let item of documentTypes" [value]="item">
              {{ item }}
            </mat-option>
          </mat-select>

          <mat-error class="error-message" *ngIf="currentForm.get('documentType')?.hasError('required') &&
              (currentForm.get('documentType')?.dirty || currentForm.get('documentType')?.touched)">
              {{ "Document Type is required"}}
          </mat-error>
          
        </mat-form-field>

        <div>
          <button *ngIf="i > 0" mat-button matStepperPrevious>
            Back
          </button>
          <button mat-button matStepperNext>
            Next
          </button>
        </div>
      </form>
      <!-- {{ currentForm.value | json }} -->
    </mat-step>
    <mat-step>
      <ng-template matStepLabel>Done</ng-template>
      <p>Click Ok to save files</p>
      <div>
        <button mat-button matStepperPrevious>
          Back
        </button>
        <button mat-button (click)="stepper.reset(); resetForms()">
          Reset
        </button>
      </div>
    </mat-step>
  </mat-vertical-stepper>
</mat-dialog-content>

<mat-dialog-actions class="adf-dialog-buttons">
  <span class="adf-fill-remaining-space"></span>

  <button mat-button id="adf-folder-cancel-button" mat-dialog-close>
    Cancel
  </button>

  <button
    *ngIf="editing"
    class="adf-dialog-action-button"
    id="broking-document-edit-button"
    mat-button
    (click)="submit()"
    [disabled]="!formsValid()"
  >
    Ok
  </button>

  <!--<adf-upload-button
    *ngIf="!editing"
    [rootFolderId]="templateHomeId"
    [nodeType]="nodeType"
    [uploadFolders]="false"
    [multipleFiles]="false"
    [acceptedFilesType]="'.doc,.pdf,.docx'"
    [versioning]="false"
    [disabled]="!form.valid"
    (success)="uploadSuccess($event)"
  >
  </adf-upload-button>-->
</mat-dialog-actions>
